// Items list for the sentiments and tags views. Its rows are the charts model's resolved tag
// list, not the question's own answer variants, so the branches the shared calculator carries
// for real variants -- thumbnails, skip-to targets, screener tags, trait breakdowns -- cannot
// fire here and are left to combo's calculator. What remains is two columns and a row per tag.
//
// Handlers arrive as callbacks, the way `onSort` always did, so nothing here depends on a `this`.

import { processText } from '@aytm/app/stats/page/components/lib/utils'
import {
  PALETTE_SIZE,
  answerSettled,
  applySorted,
  byCellValue,
  byPosition,
  hasBaseIn,
  progressTitle,
  valueCell
} from '@aytm/app/stats/page/question-views/oe/lib/table-utils'

export const calcTableProps = ({
  id,
  answer,
  answerVariants = [],
  percentDecimals,
  sortOrder,
  commentsEnabled = true,
  components,
  clickable = true,
  onSort,
  onLabelClick,
  onCommentsClick
}) => {
  const variants = (answerVariants || []).filter(av => av)
  if (!variants.length) return { cols: [], rows: [] }

  const isLoading = 'loading' == answer
  const settled = answerSettled(answer)
  const values = isLoading || undefined === answer || null === answer ? {} : answer

  const commentsOn =
    commentsEnabled && (!components || undefined === components.comments || true === components.comments)

  const cols = [
    { type: 'title', title: 'Answers', sort: byPosition },
    {
      type: 'progress',
      title: progressTitle({ answer: values, hasBase: hasBaseIn(values) }),
      percentDecimals,
      sort: byCellValue(1, 'percents')
    }
  ]

  const rows = variants.map(av => {
    const item = values[`a${av.position}`] || {}

    const titleCell = {
      title: processText(av.text),
      label: `A${av.position}`,
      colorIndex: ((av.position - 1) % PALETTE_SIZE) + 1
    }

    if (commentsOn && Object.hasOwn(item, 'comments')) {
      titleCell.comments = item.comments
      // the handlers live on the block, which no longer holds these rows -- hand them in
      titleCell.onCommentsClick = (event, position) => onCommentsClick?.(event, position, variants)
    }

    if (clickable) titleCell.onLabelClick = (event, position) => onLabelClick?.(event, position, variants)

    return { cells: [titleCell, valueCell({ item, isLoading, settled })], position: av.position }
  })

  const sortedCols = applySorted(cols, sortOrder)

  // the sort resolves the picked column out of the built set, which only exists here
  return { id, cols: sortedCols, rows, onSort: (colIndex, dir) => onSort?.(colIndex, dir, sortedCols) }
}
